import React, {PureComponent} from 'react';
import {CardCarousel} from '../../components/common/carousel/Carousel';
import {RatioCard} from '../../components/common/carousel/Card';
import {buildSerpUrl} from '../../utils/urls';
import {HeroGrid, GridPanel} from '@homeaway/landing-presentational';
import EdapViewTracker from '../../components/common/edap-view-tracker/EdapViewTracker';
import {TESTS} from '../../utils/abacus';
import MvtTest from '../../components/common/mvt/MvtTest/MvtTest';

function createRatioCard({
    isMobile,
    search,
    host,
    basePath,
    pushHandlerClickData,
}) {
    return (props, index) => {
        const {
            fullName,
            getImageUrl,
            lbsId,
            simpleName,
            subheading,
            title,
        } = props;

        const {arrivalDate, departureDate} = search;

        const urlPath = buildSerpUrl({
            basePath,
            host,
            params: {
                q: fullName,
                arrival: arrivalDate,
                departure: departureDate,
            },
        });

        return (
            <RatioCard
                altText={simpleName}
                footer={subheading}
                getImageUrl={getImageUrl}
                isMobile={isMobile}
                key={index}
                linkRel={null}
                onClick={pushHandlerClickData(lbsId, index + 1)}
                path={urlPath}
                title={title}
            />
        );
    };
}

function renderPanel({search, host, basePath, pushHandlerClickData}) {
    return (data, index) => {
        const {arrivalDate, departureDate} = search;

        const {fullName, getImageUrl, lbsId, title} = data;

        const urlPath = buildSerpUrl({
            basePath,
            host,
            params: {
                q: fullName,
                arrival: arrivalDate,
                departure: departureDate,
            },
        });

        const imageSrc = index === 0 ? getImageUrl('hw2') : getImageUrl('hw6');

        return (
            <a
                key={index}
                href={urlPath}
                onClick={pushHandlerClickData(lbsId, index + 1)}
            >
                <GridPanel label={title} imageSrc={imageSrc} />
            </a>
        );
    };
}

export class PopularDestinationsComponent extends PureComponent {
    componentDidMount() {
        const {
            basePathPrefix,
            lbsIds = [],
            popularDestinations = [],
            fetchImages,
        } = this.props;

        if (!popularDestinations.length && lbsIds.length) {
            fetchImages({basePathPrefix, lbsIds});
        }
    }

    handleNext = () => this.props.pushHandlerNext();

    handlePrev = () => this.props.pushHandlerPrev();

    render() {
        const {
            cityCarouselTitle,
            isMobile,
            popularDestinations = [],
            search,
            basePath,
            host,
            moduleHeading,
            showNewHeadings,
            ACTION_LOCATION,
            pushHandlerClickData,
            showUpdatedPopularDestinations,
            cardTitlesDisplayed,
            cardTitlesLoaded,
        } = this.props;

        if (!popularDestinations.length) {
            return null;
        }

        let body;
        let sectionClasses;

        if (showUpdatedPopularDestinations) {
            sectionClasses = 'container module';

            body = (
                <HeroGrid
                    items={popularDestinations}
                    renderPanel={renderPanel({
                        search,
                        host,
                        basePath,
                        pushHandlerClickData,
                    })}
                />
            );
        } else {
            sectionClasses =
                'container module module--no-padding popular-destinations-ratio-cards';

            const cards = popularDestinations.map(
                createRatioCard({
                    isMobile,
                    search,
                    host,
                    basePath,
                    pushHandlerClickData,
                })
            );

            body = (
                <CardCarousel
                    titleMessage={showNewHeadings ? null : cityCarouselTitle}
                    onNextClick={this.handleNext}
                    onPreviousClick={this.handlePrev}
                >
                    {cards}
                </CardCarousel>
            );
        }

        return (
            <MvtTest test={TESTS.LANDING_UPDATE_POPULAR_DESTINATION}>
                <div className={sectionClasses}>
                    <EdapViewTracker
                        eventData={{
                            action_location: ACTION_LOCATION,
                            position_fired: 'top',
                            card_titles_displayed: cardTitlesDisplayed,
                            card_titles_loaded: cardTitlesLoaded,
                        }}
                        edapEvent={'content_module.presented'}
                    />
                    {showNewHeadings && (
                        <h2 className="page-heading heading--with-padding">
                            {moduleHeading}
                        </h2>
                    )}
                    {(showNewHeadings || showUpdatedPopularDestinations) && (
                        <h3
                            className={
                                showUpdatedPopularDestinations
                                    ? 'page-subheading'
                                    : 'page-subheading heading--with-padding'
                            }
                        >
                            {cityCarouselTitle}
                        </h3>
                    )}
                    {body}
                    <EdapViewTracker
                        eventData={{
                            action_location: ACTION_LOCATION,
                            position_fired: 'bottom',
                            card_titles_displayed: cardTitlesDisplayed,
                            card_titles_loaded: cardTitlesLoaded,
                        }}
                        edapEvent={'content_module.presented'}
                    />
                    <EdapViewTracker
                        eventData={{actionlocation: ACTION_LOCATION}}
                    />
                </div>
            </MvtTest>
        );
    }
}

export default PopularDestinationsComponent;
